import { ALLOWED_UPLOAD_EXTENSIONS } from "@/constants/files";

export function partitionUploadFiles(
  allFiles: File[],
  allowedExtensions: ReadonlySet<string> = ALLOWED_UPLOAD_EXTENSIONS,
): { accepted: File[]; rejected: string[] } {
  const accepted: File[] = [];
  const rejected: string[] = [];

  for (const file of allFiles) {
    const dot = file.name.lastIndexOf(".");
    const ext = dot === -1 ? "" : file.name.slice(dot).toLowerCase();
    if (ext && allowedExtensions.has(ext)) {
      accepted.push(file);
    } else {
      rejected.push(file.name);
    }
  }

  return { accepted, rejected };
}

function fileKey(file: File): string {
  return `${file.name}:${file.size}:${file.lastModified}`;
}

export function mergeUploadFiles(
  existing: File[],
  incoming: File[],
  maxFiles: number,
): { files: File[]; overflow: number } {
  const seen = new Set(existing.map(fileKey));
  const files = [...existing];
  let overflow = 0;

  for (const file of incoming) {
    const key = fileKey(file);
    if (seen.has(key)) continue;
    if (files.length >= maxFiles) {
      overflow++;
      continue;
    }
    seen.add(key);
    files.push(file);
  }

  return { files, overflow };
}
